"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapWithConcurrency = void 0;
/**
 * Runs `task` over every item, keeping at most `concurrency` promises in flight.
 *
 * `Promise.all(items.map(task))` starts every task at once. Against Firestore that
 * opens one connection per item, and a few thousand items is enough for the backend
 * to start rate limiting the client.
 *
 * Results keep the order of `items`. The first rejection is rethrown and stops the
 * remaining items from being started.
 */
async function mapWithConcurrency(items, concurrency, task) {
    if (concurrency < 1) {
        throw new Error(`Concurrency must be at least 1, got ${concurrency}`);
    }
    const results = new Array(items.length);
    let nextIndex = 0;
    let failed = false;
    const worker = async () => {
        while (nextIndex < items.length && !failed) {
            const index = nextIndex++;
            try {
                results[index] = await task(items[index], index);
            }
            catch (error) {
                failed = true;
                throw error;
            }
        }
    };
    await Promise.all(Array.from({ length: Math.min(concurrency, items.length) }, async () => await worker()));
    return results;
}
exports.mapWithConcurrency = mapWithConcurrency;
